import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    title: {
      fontSize: 18,
      fontWeight: 700,
    },
    text: { fontSize: 16 },
  };
});

const ExpiredSubInfo = ({ anchorInfo }) => {
  const classes = useStyles();

  return (
    <Box
      alignItems="center"
      display="flex"
      height="100%"
      justifyContent="center"
    >
      <Box textAlign="center">
        <Typography className={classes.title}>
          Your subscription has expired
        </Typography>
        <Typography className={classes.text}>
          To send and receive messages from {anchorInfo && anchorInfo.username} you need to renew your subscription.
        </Typography>
      </Box>
    </Box>
  );
};

export default ExpiredSubInfo;
